module.exports = __webpack_public_path__ + "img/business2.a70fec44.png";